import { render } from "./Call.vue?vue&type=template&id=b85ac7f2&scoped=true"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"

import "./Call.vue?vue&type=style&index=0&id=b85ac7f2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85ac7f2"]])

export default __exports__